import { CouponInterface } from 'modules/coupons/types/coupon-interface'

interface CouponDataInterface {
  id: number
  caption: string
}

export const getAvailableCouponsData = (
  coupons?: CouponInterface[],
  type?: CouponInterface['discountType'],
) => {
  return coupons
    ?.filter(coupon => {
      if (!type) {
        return true
      }
      return coupon.discountType === type
    })
    .map(coupon => {
      return {
        id: coupon.id,
        caption: coupon.innerName,
      }
    }, [] as CouponDataInterface[])
}
